import { createSelector } from '@reduxjs/toolkit';
import { selectBusinessById } from '../business/selectors';
import type { PostModel } from './types';
import type { RootState } from '../store';

const selectState = (state: RootState): RootState['posts'] => state.posts;

export const selectPostById = createSelector(
    [
        (state: RootState) => state,
        (state: RootState) => selectState(state).records,
        (state: RootState, postId: string = ''): string => postId,
    ],
    (state, records, postId): PostModel | undefined => {
        const model = records[postId];

        return model
            ? {
                  ...model,
                  business: selectBusinessById(state, model.business)!,
              }
            : undefined;
    },
);

export const selectPostCollection = createSelector(
    [(state) => state, (state: RootState, namespace: string): string => namespace],
    (draft, category) => {
        const identifiers = draft.posts.collections[category]?.identifiers ?? [];

        return {
            next: draft.posts.collections[category]?.next,
            items: identifiers
                .map((id: string) => selectPostById(draft, id))
                .filter(Boolean) as PostModel[],
        };
    },
);

export const selectPostCollectionLoading = createSelector(
    [selectState, (state: RootState, namespace: string): string => namespace],
    (draft, category): boolean => draft.collections[category]?.isLoading ?? false,
);
